export const ReviewingRequestAnimation = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      preserveAspectRatio="xMidYMid meet"
      width="1138"
      height="640"
      viewBox="0 0 1138 640"
      className="text-primary mx-auto h-16 w-full"
    >
      <defs>
        <filter id="card-shadow" x="-50%" y="-50%" width="200%" height="200%" colorInterpolationFilters="sRGB">
          <feDropShadow dx="0" dy="2" stdDeviation="2" floodColor="#000000" floodOpacity="0.06" />
          <feDropShadow dx="0" dy="6" stdDeviation="8" floodColor="#000000" floodOpacity="0.10" />
        </filter>
        <animate
          repeatCount="indefinite"
          dur="10s"
          begin="0s"
          xlinkHref="#_R_G_L_3_G"
          fill="freeze"
          attributeName="opacity"
          from="1"
          to="1"
          keyTimes="0;0.5041667;1"
          values="1;1;1"
          keySplines="0.167 0.167 0.833 0.833;0 0 0 0"
          calcMode="spline"
        />
        <animateMotion
          repeatCount="indefinite"
          dur="10s"
          begin="0s"
          xlinkHref="#_R_G_L_3_G"
          fill="freeze"
          keyTimes="0;0.9;1"
          path="M583 320 C583,320 583,320 583,320 C583,320 583,160 583,160 "
          keyPoints="0;0;1"
          keySplines="0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833"
          calcMode="spline"
        />
        <animate
          repeatCount="indefinite"
          dur="10s"
          begin="0s"
          xlinkHref="#_R_G_L_3_G_M"
          fill="freeze"
          attributeName="opacity"
          from="0"
          to="1"
          keyTimes="0;0.5;0.5000004;1"
          values="0;0;1;1"
          keySplines="0 0 0 0;0 0 0 0;0 0 0 0"
          calcMode="spline"
        />
        <animate
          repeatCount="indefinite"
          dur="10s"
          begin="0s"
          xlinkHref="#_R_G_L_2_G"
          fill="freeze"
          attributeName="opacity"
          from="1"
          to="0"
          keyTimes="0;0.05;0.4;0.45;1"
          values="1;1;1;0;0"
          keySplines="0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0 0 0 0"
          calcMode="spline"
        />
        <animateMotion
          repeatCount="indefinite"
          dur="10s"
          begin="0s"
          xlinkHref="#_R_G_L_2_G"
          fill="freeze"
          keyTimes="0;0.4;0.4958333;1"
          path="M583 160 C583,160 583,160 583,160 C583,160 583,4 583,4 C583,4 583,4 583,4 "
          keyPoints="0;0;1;1"
          keySplines="0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0 0 0 0"
          calcMode="spline"
        />
        <animate
          repeatCount="indefinite"
          dur="10s"
          begin="0s"
          xlinkHref="#_R_G_L_2_G_M"
          fill="freeze"
          attributeName="opacity"
          from="1"
          to="0"
          keyTimes="0;0.5;0.5;1"
          values="1;1;0;0"
          keySplines="0 0 0 0;0 0 0 0;0 0 0 0"
          calcMode="spline"
        />
        <animate
          repeatCount="indefinite"
          dur="10s"
          begin="0s"
          xlinkHref="#_R_G_L_1_G"
          fill="freeze"
          attributeName="opacity"
          from="1"
          to="0"
          keyTimes="0;0.025;0.9;0.95;1"
          values="1;1;1;0;0"
          keySplines="0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0 0 0 0"
          calcMode="spline"
        />
        <animateMotion
          repeatCount="indefinite"
          dur="10s"
          begin="0s"
          xlinkHref="#_R_G_L_1_G"
          fill="freeze"
          keyTimes="0;0.4;0.5;0.9;0.9958333;1"
          path="M583 320 C583,320 583,320 583,320 C583,320 583,160 583,160 C583,160 583,160 583,160 C583,160 583,4 583,4 C583,4 583,4 583,4 "
          keyPoints="0;0;0.51;0.51;1;1"
          keySplines="0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0 0 0 0"
          calcMode="spline"
        />
        <animate
          repeatCount="indefinite"
          dur="10s"
          begin="0s"
          xlinkHref="#_R_G_L_0_G_D_3_P_0"
          fill="freeze"
          attributeName="fill-opacity"
          from="0"
          to="0"
          keyTimes="0;0.1;0.3;0.5;0.7;0.9;1"
          values="0;0;0.33;0.33;0;0;0"
          keySplines="0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0 0 0 0"
          calcMode="spline"
        />
        <animate
          repeatCount="indefinite"
          dur="10s"
          begin="0s"
          xlinkHref="#_R_G_L_0_G_D_8_P_0"
          fill="freeze"
          attributeName="fill-opacity"
          from="0.33"
          to="0.33"
          keyTimes="0;0.1;0.3;0.5;0.7;0.9;1"
          values="0.33;0.33;0.04;0.04;0.33;0.33;0.33"
          keySplines="0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0 0 0 0"
          calcMode="spline"
        />
        <animate
          repeatCount="indefinite"
          dur="10s"
          begin="0s"
          xlinkHref="#_R_G_L_0_G_D_9_P_0"
          fill="freeze"
          attributeName="fill-opacity"
          from="1"
          to="1"
          keyTimes="0;0.1;0.5;0.9;1"
          values="1;1;0;1;1"
          keySplines="0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0 0 0 0"
          calcMode="spline"
        />
        <animate
          repeatCount="indefinite"
          dur="10s"
          begin="0s"
          xlinkHref="#_R_G_L_0_G_D_10_P_0"
          fill="freeze"
          attributeName="fill-opacity"
          from="1"
          to="1"
          keyTimes="0;0.1;0.3;0.5;0.7;0.9;1"
          values="1;1;0;0;1;1;1"
          keySplines="0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0 0 0 0"
          calcMode="spline"
        />
        <animateMotion
          repeatCount="indefinite"
          dur="10s"
          begin="0s"
          xlinkHref="#_R_G_L_0_G"
          fill="freeze"
          keyTimes="0;0.5;1"
          path="M310.51 324.57 C458.4,324.46 818.51,324.57 818.51,324.57 C818.51,324.57 289.68,324.58 310.51,324.57 "
          keyPoints="0;0.5;1"
          keySplines="0.333 0 0.667 1;0.333 0 0.833 0.833"
          calcMode="spline"
        />
        <animateTransform
          repeatCount="indefinite"
          dur="10s"
          begin="0s"
          xlinkHref="#_R_G_L_0_G"
          fill="freeze"
          attributeName="transform"
          from="30.455"
          to="30.455"
          type="rotate"
          additive="sum"
          keyTimes="0;0.5;1"
          values="30.455;68.455;30.455"
          keySplines="0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833"
          calcMode="spline"
        />
        <animateTransform
          repeatCount="indefinite"
          dur="10s"
          begin="0s"
          xlinkHref="#_R_G_L_0_G"
          fill="freeze"
          attributeName="transform"
          from="3.41 3.41"
          to="3.41 3.41"
          type="scale"
          additive="sum"
          keyTimes="0;1"
          values="3.41 3.41;3.41 3.41"
          keySplines="0 0 1 1"
          calcMode="spline"
        />
        <animateTransform
          repeatCount="indefinite"
          dur="10s"
          begin="0s"
          xlinkHref="#_R_G_L_0_G"
          fill="freeze"
          attributeName="transform"
          from="-49 -49"
          to="-49 -49"
          type="translate"
          additive="sum"
          keyTimes="0;1"
          values="-49 -49;-49 -49"
          keySplines="0 0 1 1"
          calcMode="spline"
        />
        <animate attributeType="XML" attributeName="opacity" dur="10s" from="0" to="1" xlinkHref="#time_group" />
      </defs>
      <g id="_R_G">
        <g id="_R_G_L_3_G_M">
          <g id="_R_G_L_3_G">
            <path
              id="_R_G_L_3_G_D_0_P_0"
              stroke="#f4f4f4"
              strokeLinecap="round"
              strokeLinejoin="round"
              fill="none"
              strokeWidth="80"
              strokeOpacity="1"
              d=" M-285 102 C-285,102 257,102 257,102 "
            />
          </g>
        </g>
        <g id="_R_G_L_2_G_M">
          <g id="_R_G_L_2_G">
            <path
              id="_R_G_L_2_G_D_0_P_0"
              stroke="#f4f4f4"
              strokeLinecap="round"
              strokeLinejoin="round"
              fill="none"
              strokeWidth="80"
              strokeOpacity="1"
              d=" M-285 102 C-285,102 257,102 257,102 "
            />
          </g>
        </g>
        <g id="_R_G_L_1_G">
          <path
            id="_R_G_L_1_G_D_0_P_0"
            stroke="#f4f4f4"
            strokeLinecap="round"
            strokeLinejoin="round"
            fill="none"
            strokeWidth="80"
            strokeOpacity="1"
            d=" M-285 102 C-285,102 257,102 257,102 "
          />
        </g>
        <g id="magnifier-shadow" filter="url(#card-shadow)">
          <g id="_R_G_L_0_G">
            <path
              id="_R_G_L_0_G_D_2_P_0"
              className="fill-primary-light"
              fillOpacity="0.5"
              fillRule="nonzero"
              d=" M34 63 C17.98,63 5,50.02 5,34 C5,17.98 17.98,5 34,5 C50.02,5 63,17.98 63,34 C63,50.02 50.02,63 34,63z "
            />
            <path
              id="_R_G_L_0_G_D_3_P_0"
              fill="#585858"
              fillOpacity="0"
              fillRule="nonzero"
              d=" M36 3 C52.02,3 65,15.98 65,32 C65,40.52 61.33,48.18 55.48,53.48 C60.15,48.33 63,41.5 63,34 C63,17.98 50.02,5 34,5 C26.5,5 19.67,7.85 14.52,12.52 C19.82,6.67 27.48,3 36,3z  M14.52 12.52 C9.85,17.67 7,24.5 7,32 C7,48.02 19.98,61 36,61 C43.5,61 50.33,58.15 55.48,53.48 C50.18,59.33 42.52,63 34,63 C17.98,63 5,50.02 5,34 C5,25.48 8.67,17.82 14.52,12.52z "
            />
            <path
              id="_R_G_L_0_G_D_4_P_0"
              fill="#757575"
              fillOpacity="1"
              fillRule="nonzero"
              d=" M58.44 51.38 C58.44,51.38 51.38,58.43 51.38,58.43 C51.38,58.43 71.67,78.73 71.67,78.73 C71.67,78.73 78.73,71.67 78.73,71.67 C78.73,71.67 58.44,51.38 58.44,51.38z "
            />
            <path
              id="_R_G_L_0_G_D_5_P_0"
              fill="#000000"
              fillOpacity="0.24"
              fillRule="nonzero"
              d=" M58.44 51.38 C58.44,51.38 51.38,58.43 51.38,58.43 C51.38,58.43 56,63.06 56,63.06 C56,63.06 57.5,63 60,60.5 C62.5,58 63.06,56 63.06,56 C63.06,56 58.44,51.38 58.44,51.38z "
            />
            <path
              id="_R_G_L_0_G_D_6_P_0"
              fill="currentColor"
              fillOpacity="1"
              fillRule="nonzero"
              d=" M95.52 95.51 C98.83,92.2 98.83,86.82 95.52,83.51 C95.52,83.51 72.81,60.8 72.81,60.8 C71.57,59.57 69.57,59.57 68.34,60.8 C68.34,60.8 60.81,68.33 60.81,68.33 C59.57,69.57 59.57,71.57 60.81,72.8 C60.81,72.8 83.51,95.51 83.51,95.51 C86.83,98.83 92.2,98.83 95.52,95.51z "
            />
            <path
              id="_R_G_L_0_G_D_7_P_0"
              fill="currentColor"
              fillOpacity="1"
              fillRule="nonzero"
              d=" M34.12 5.53 C49.9,5.53 62.7,18.33 62.7,34.11 C62.7,49.9 49.9,62.7 34.12,62.7 C18.33,62.7 5.54,49.9 5.54,34.11 C5.54,18.33 18.33,5.53 34.12,5.53z  M34.12 0 C15.28,0 0,15.28 0,34.12 C0,52.96 15.28,68.23 34.12,68.23 C52.96,68.23 68.23,52.96 68.23,34.12 C68.23,15.28 52.96,0 34.12,0z "
            />
            <path
              id="_R_G_L_0_G_D_8_P_0"
              fill="#000000"
              fillOpacity="0.33"
              fillRule="nonzero"
              d=" M60.81 68.34 C60.81,68.34 65.54,63.61 65.54,63.61 C64.3,64.84 64.3,66.84 65.54,68.08 C65.54,68.08 88.24,90.79 88.24,90.79 C90.72,93.26 94.34,93.89 97.4,92.67 C96.98,93.7 96.36,94.68 95.52,95.52 C92.2,98.83 86.83,98.83 83.51,95.52 C83.51,95.52 60.81,72.81 60.81,72.81 C59.57,71.57 59.57,69.57 60.81,68.34z "
            />
            <path
              id="_R_G_L_0_G_D_9_P_0"
              fill="#ffffff"
              fillOpacity="1"
              fillRule="nonzero"
              d=" M38.95 8.13 C42.67,9.18 45.26,11.53 44.74,13.39 C44.22,15.26 40.78,15.92 37.05,14.87 C33.33,13.83 30.74,11.47 31.26,9.61 C31.78,7.75 35.23,7.08 38.95,8.13z "
            />
            <path
              id="_R_G_L_0_G_D_10_P_0"
              fill="#ffffff"
              fillOpacity="1"
              fillRule="nonzero"
              d=" M49 14 C50.11,14 51,14.9 51,16 C51,17.11 50.11,18 49,18 C47.9,18 47,17.11 47,16 C47,14.9 47.9,14 49,14z "
            />
          </g>
        </g>
      </g>
      <g id="time_group" />
    </svg>
  )
}
